export default value => (
  value >= 1000 ? {
    val: value / 1000,
    unit: 'km',
    singular: 'Kilometer',
    plural: 'Kilometers',
  } : {
    val: value,
    unit: 'm',
    singular: 'Meter',
    plural: 'Meters',
  }
)
